import { useNavigate } from "react-router-dom";
import { MapPin, Clock, ClipboardList, ChevronRight } from "lucide-react";
import { StatusPill } from "./StageBar";

export function JobCard({ job }) {
  const navigate = useNavigate();
  const remaining = (job.tasks || []).filter((t) => !t.done).length;
  const time = new Date(job.scheduled_date).toLocaleTimeString([], { hour: "numeric", minute: "2-digit" });

  return (
    <button
      onClick={() => navigate(`/field/jobs/${job.id}`)}
      className="hw-card w-full p-5 text-left transition active:scale-[0.99] hover:border-cyan-500/40"
      data-testid={`job-card-${job.id}`}
    >
      <div className="flex items-start justify-between">
        <div className="flex items-center gap-2">
          <span className="hw-badge"><Clock size={12} /> {time}</span>
          <span className="rounded-full bg-slate-800 px-2.5 py-1 text-xs font-semibold text-slate-300">{job.phase}</span>
        </div>
        <StatusPill status={job.status} />
      </div>
      <div className="mt-3 font-head text-2xl font-bold text-white">{job.title}</div>
      <div className="mt-1 flex items-center gap-1.5 text-sm text-slate-400">
        <MapPin size={14} /> {job.address}
      </div>
      <div className="mt-4 flex items-center justify-between border-t border-slate-800 pt-3">
        <span className="flex items-center gap-1.5 text-sm text-cyan-300">
          <ClipboardList size={15} /> {remaining} tasks remaining
        </span>
        <ChevronRight size={20} className="text-slate-500" />
      </div>
    </button>
  );
}
